import React from "react";
import Header from "./header.js";
import BreadCrumbs from "./breadcrumbs.js";
import Footer from "./footer.js";
import Seo from "./seo.js";
import Ad from "./ad.js";
import PopularIcons from "./popular-icons.js";
import "../styles/main.scss";

const Layout = ({ children, infos }) => {
  return (
    <>
      <Seo infos={ infos } />
      <Header className={ infos?.type === "home" ? "homepage":(infos?.type || "") } />
      {
        infos?.type === "home"
        ? <main>
            {children}
            <Ad />
            <PopularIcons />
          </main>
        : <main>
            <Ad />
            <BreadCrumbs infos={infos} />
            {children}
          </main>
      }
      <Footer />
    </>
  );
};
export default Layout;
